import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Immutable from 'immutable';

import { catalogBibShape } from '@bibliocommons/bc-prop-types';

import {
  FullScreenOverlayBody,
  FullScreenOverlayHeader,
  FullScreenOverlayContent
} from 'app/components/shared/FullScreenOverlay';
import Heading from 'app/components/shared/Heading';
import BibSeries from 'app/components/bibs/shared/BibSeries';
import { TableStencil } from 'app/components/shared/Table';
import { sameSeriesShape } from 'app/shapes/bibPage';

import './SameSeriesOverlay.scss';

export default class SameSeriesOverlay extends React.PureComponent {
  componentDidMount() {
    this.props.fetchSeriesInfo(this.props.catalogBib.get('metadataId'));
  }

  render() {
    const { series, catalogBib, isFetching } = this.props;

    const bibs = series.get('seriesEntries', Immutable.List());

    return (
      <FullScreenOverlayBody className="cp-same-series-overlay">
        <FullScreenOverlayHeader title={<FormattedMessage id="in_the_same_series" />} />
        <FullScreenOverlayContent size="small">
          {isFetching ? (
            <TableStencil />
          ) : (
            <>
              <Heading tagName="h3" size="moderate" variant className="same-series-heading">
                {series.get('seriesTitle')}
              </Heading>
              <BibSeries bibs={bibs} catalogBib={catalogBib} />
            </>
          )}
        </FullScreenOverlayContent>
      </FullScreenOverlayBody>
    );
  }
}

SameSeriesOverlay.propTypes = {
  catalogBib: catalogBibShape,
  fetchSeriesInfo: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  series: sameSeriesShape.isRequired
};
